import { makeStyles } from '@material-ui/core';

export const getProposalPreviewDefaultEnergyProductionChartStyles = makeStyles(
  () => ({
    caption: {
      paddingBottom: '2mm',
    },
  }),
);
